import { currencies, currencyTextsConfig } from '../constants/dossier/common/currencies'
import Settings from './settings'

export default {
  ...Settings,
  url: 'http://localhost/BackEnd-iDocCar/api/',
  IdocSingUrl: 'http://localhost:4200/sign-app/login',
  urlHotFolder: '',
  webSocketUrl: 'wss://localhost:8009',
  notificationRefresh: 60000,
  showSignDocumentButton: false,
  acceptFileFormats: 'application/pdf, .jpg, .png, .jpeg, .gif, .docx, .doc, .xls, .xlsx, .ppt, .pptx, .msg, .tiff',
  qaSite: true,
  dealerMaxLength: 7,
  dealerNumberRegex: null,
  autoLoadDashboard: false,
  maxTagCount: 2,
  maxTagTextLength: 10,
  matomoUrl: 'https://localhost',
  matomoSiteId: '0',
  authenticationWithSalt: false,
  clientFieldValidation: 'buss',
  validateLicensePlate: null,
  currency: currencies.USD,
  currencyRegex: [/^[$][+-]?(\d{1,3}\.(\d{3}\.)*\d{3}|\d*)(,\d+)?$/, /^[+-][$]?(\d{1,3}\.(\d{3}\.)*\d{3}|\d*)(,\d+)?$/],
  currencyTextConfig: currencyTextsConfig.USD
}
